<template>
  <md-app md-mode="fixed">
    <md-app-drawer
      :md-active.sync="menuVisible"
      :md-right="true"
    >
      <div class="md-layout close-icon">
        <md-button
          class="md-icon-button"
          @click="menuVisible = !menuVisible"
        >
          <md-icon>close</md-icon>
        </md-button>
      </div>
      <secondary-nav-bar />
      <div class="md-layout md-alignment-center-center">
        <md-button @click="loginUser">
          Login & Watch Experience
        </md-button>
      </div>
    </md-app-drawer>
    <md-app-content>
      <div class="login-bg">
        <div class="md-layout welcome login">
          <div class="md-layout welcome-content-image">
            <kab-logo class="kabs-logo" />
            <div class="md-layout menu-icon">
              <md-button
                class="md-icon-button"
                @click="menuVisible = !menuVisible"
              >
                <md-icon>menu</md-icon>
              </md-button>
            </div>
            <welcome />
          </div>
        </div>
        <div>
          <Footer />
        </div>
      </div>
    </md-app-content>
  </md-app>
</template>

<script>
import Welcome from "@/components/Welcome"
import KabLogo from "@/components/KabLogo"
import Footer from "@/components/Footer"
import KabTrailer from "@/components/KabTrailer"
import SecondaryNavBar from "@/components/NavBar/SecondaryNavBar"
export default {
  name: "Login",
  components: {
    Welcome,
    KabLogo,
    Footer,
    SecondaryNavBar,
  },
  data () {
    return {
      menuVisible: false
    }
  },
  methods: {  
    loginUser() {
      this.$router.push('/login')
    }
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.welcome-content-image {
  background: url('~@/assets/kab20_4.gif');
  background-size: cover;
  z-index: 9999;
}
.login-bg {
  background-color: #f2f5f7;
}
.login {
  height: 100vh !important;
}
.trailer-content {
  margin: 10px 13% auto 13%;
  width: 100%;
  height: 70vh;
}
.kabs-logo {
  position: absolute;
  left: 1%;
  z-index: 9
}
.menu-icon {
  position: absolute;
  right: 2%;
  .md-icon {
    color: #ffffff !important;
    font-size: 40px !important;
  }
}
.close-icon {
  @extend .menu-icon;
  .md-icon {
    color: $color-black !important;
    font-size: 25px !important;
  }
}
.menu-items {
  display: flex;
  max-height: 71px;
  img {
    margin: 5px 0px 5px 21px;
  }
}
</style>
